module.exports = __webpack_public_path__ + "img/Logo-35.321936b6.svg";